<div>
    <!-- FIXME: AG Grid's overlay component -->
    <app-loader [loadingMessage]="loadingMessage"></app-loader>
</div>
